import FieldSet from '../../FieldSet';
import { InitialEstimate } from './InitialEstimate';
import { InitialEstimateWithIcon } from './InitialEstimateWithIcon';

export class InitialEstimateFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [InitialEstimate, InitialEstimateWithIcon];
  }

  get title() {
    return 'Initial estimate';
  }
}
